 import { useState } from 'react';
import { PREFERRED_COUNTRIES, STUDY_LEVELS, FIELDS_OF_STUDY } from './lib/constants';
import { useForm } from './form-provider';

export function StepTwo() {
  const { formData, updateFormData, setStep } = useForm();
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const filteredFields = FIELDS_OF_STUDY.filter((field) =>
    field.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const [touchedFields, setTouchedFields] = useState({
    preferredCountry: false,
    studyLevel: false,
    fieldOfStudy: false
  });

  const handleNext = () => {
    setTouchedFields({
      preferredCountry: true,
      studyLevel: true,
      fieldOfStudy: true
    });

    if (formData.preferredCountry && formData.studyLevel && formData.fieldOfStudy) {
      setStep(3);
    }
  };

  const getInputClassName = (fieldName) => {
    const baseClasses = "mt-1 block w-full rounded-md border shadow-sm focus:ring focus:ring-indigo-200 focus:ring-opacity-50 px-4 py-2.5";
    const isError = touchedFields[fieldName] && !formData[fieldName];
    
    return `${baseClasses} ${
      isError
        ? "border-red-500 focus:border-red-500"
        : "border-gray-300 focus:border-indigo-300"
    }`;
  };

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <label htmlFor="preferredCountry" className="block text-sm font-medium text-gray-700">
          Preferred Country for Education
        </label>
        <select
          id="preferredCountry"
          className={getInputClassName('preferredCountry')}
          value={formData.preferredCountry}
          onChange={(e) => {
            updateFormData({ preferredCountry: e.target.value });
            setTouchedFields(prev => ({ ...prev, preferredCountry: true }));
          }}
          onBlur={() => setTouchedFields(prev => ({ ...prev, preferredCountry: true }))}
        >
          <option value="">Select country</option>
          {PREFERRED_COUNTRIES.map((country) => (
            <option key={country} value={country}>{country}</option>
          ))}
        </select>
        {touchedFields.preferredCountry && !formData.preferredCountry && (
          <p className="mt-1 text-sm text-red-500">Please select a country</p>
        )}
      </div>

      <div className="space-y-2">
        <label htmlFor="studyLevel" className="block text-sm font-medium text-gray-700">
          Level of Study
        </label>
        <select
          id="studyLevel"
          className={getInputClassName('studyLevel')}
          value={formData.studyLevel}
          onChange={(e) => {
            updateFormData({ studyLevel: e.target.value });
            setTouchedFields(prev => ({ ...prev, studyLevel: true }));
          }}
          onBlur={() => setTouchedFields(prev => ({ ...prev, studyLevel: true }))}
        >
          <option value="">Select level</option>
          {STUDY_LEVELS.map((level) => (
            <option key={level} value={level}>{level}</option>
          ))}
        </select>
        {touchedFields.studyLevel && !formData.studyLevel && (
          <p className="mt-1 text-sm text-red-500">Please select a study level</p>
        )}
      </div>

      <div className="space-y-2">
      <label htmlFor="fieldOfStudy" className="block text-sm font-medium text-gray-700">
        Field of Study
      </label>
      <div className="relative">
        <input
          id="fieldOfStudy"
          type="text"
          className={getInputClassName('fieldOfStudy')}
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setIsDropdownOpen(true);
          }}
          onFocus={() => setIsDropdownOpen(true)}
          onBlur={() => setTimeout(() => setIsDropdownOpen(false), 200)} // Delay to allow click
          placeholder="Search field..."
        />
        {isDropdownOpen && (
          <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-40 overflow-y-auto">
            {filteredFields.length > 0 ? (
              filteredFields.map((field) => (
                <li
                  key={field}
                  className="px-3 py-2 text-sm cursor-pointer hover:bg-gray-200"
                  onMouseDown={() => {
                    updateFormData({ fieldOfStudy: field });
                    setSearchTerm(field);
                    setIsDropdownOpen(false);
                    setTouchedFields(prev => ({ ...prev, fieldOfStudy: true }));
                  }}
                >
                  {field}
                </li>
              ))
            ) : (
              <li className="px-3 py-2 text-sm text-gray-500">No results found</li>
            )}
          </ul>
        )}
      </div>
      {touchedFields.fieldOfStudy && !formData.fieldOfStudy && (
        <p className="mt-1 text-sm text-red-500">Please select a field of study</p>
      )}
      </div>

      <div className="flex gap-4">
        <button
          className="w-full bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={() => setStep(1)}
        >
          Previous
        </button>
        <button
          className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </div>
  );
}